import { Heading as ChakraHeading, Icon } from '@chakra-ui/react';
import { LinkIcon } from '@heroicons/react/outline';

/**
 * A custom heading component that shows an anchor link icon on hover
 */
export const Heading = ({
  children,
  ...props
}: React.ComponentProps<typeof ChakraHeading>) => {
  return (
    <ChakraHeading
      size={props.as as string}
      mt={8}
      {...props}
      sx={{
        scrollMarginTop: 'calc(75px + var(--chakra-space-8))'
      }}
      role="group"
    >
      <span>{children}</span>
      <a href={`#${props.id}`} aria-hidden="true" tabIndex={-1}>
        <Icon
          as={LinkIcon}
          boxSize={4}
          display="none"
          color="gray.500"
          ml={2}
          _groupHover={{
            display: 'inline-block'
          }}
        />
      </a>
    </ChakraHeading>
  );
};
